import React, {useEffect, useState} from "react";
import Header from "../Components/Header";
import DashBoardHeader from "../Components/DashHeader";
import DashBoardBodyHappyPay from "../Components/happypay/DashBoardBodyHappyPay";
import {message, Spin} from "antd";
import axios from "axios";
import {useNavigate} from "react-router-dom";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const DashBoardHappyPay = () => {
    const [custname, setCustname] = useState("");
    const [auth, setAuth] = useState(null);
    const [custInfo, setCustInfo] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const initializeData = async (authData) => {
            try {
                await fetchData(authData);
                setIsLoading(false);
            } catch (error) {
                // `error.response` is undefined for a network/CORS failure, and
                // reading .status on it threw inside this very handler — turning
                // a connection problem into a blank page instead of a message.
                const status = error.response?.status;
                const serverMessage = error.response?.data?.message;

                // The API answers 401 for two unrelated reasons — an invalid DAN
                // session ("Шинээр нэвтрэнэ үү.") and a regnum missing from
                // GB.CUST ("Customer not found"). Showing one phrase for both
                // makes a misconfigured test login impossible to tell apart, so
                // keep the customer-facing wording but log what the API said.
                console.error("Happy Pay dashboard load failed", {status, serverMessage});

                if (status === 401) {
                    // Drop the session the server just rejected. Without this the
                    // customer cannot get back in: /login sends anyone holding
                    // localData straight to their dashboard, which 401s and
                    // returns them here — a loop with no way to reach the form.
                    // Only on 401, so a network blip does not log anyone out.
                    localStorage.removeItem("localData");
                    message.warning("Дахин нэвтрэнэ үү");
                } else {
                    message.warning("Сервертэй холбогдоход алдаа гарлаа та түр хүлээж дахин оролдоно уу");
                }
                navigate("/")
            }
        };
        const items = JSON.parse(localStorage.getItem('localData'));
        if (items) {
            if (items.type === "happypay") {
                setAuth(items);
                initializeData(items);
            } else if (items.type === "apple") {
                navigate("/dashboardapple");
            } else if (items.type === "visa") {
                navigate("/dashboardvisa");
            } else if (items.type === "saving") {
                navigate("/dashboardsaving");
            } else {
                localStorage.removeItem("localData");
                message.warning("Нэвтэрнэ үү!");
                navigate("/login");
            }
        } else {
            navigate("/login");
        }
    }, []);

    const fetchData = async (authData) => {
        const response = await axios.get(`${BASE_URL}/happypay/campaigns/happy-pay-cust.php`, {
            params: {...authData}
        });
        if (response.status === 200 && response.data) {
            const data = response.data;

            if (data.custname) {
                setCustname(data.custname);
            }

            setCustInfo({
                lotteryCount: data.lotteryCount || 0,
                transactionsCount: data.transactionsCount || 0,
                referralsCount: data.referralsCount || 0,
                cardLinked: data.cardLinked || false,
                promocodeLinked: data.promocodeLinked || false,
                eligible: data.eligible || false,
                influencer: data.influencer
            });
        }
    };

    return (
        <div className='hp-page w-full'>
            <Header/>
            {isLoading ? (
                <div className="w-full h-full flex justify-center align-middle mt-[15%]">
                    <Spin/>
                </div>
            ) : (
                <div className='hp-page-body w-full px-40 py-8 bg-slate-200 space-y-8 flex flex-col mobile:px-4 laptop:px-20'>
                    <DashBoardHeader name={custname ? custname : "Харилцагч"}/>
                    <DashBoardBodyHappyPay props={custInfo} auth={auth}/>
                </div>
            )}

        </div>
    )
}

export default DashBoardHappyPay;